import React from 'react';
import { Chip } from '@mui/material';
import { mergeSlotProps } from '@mui/material/utils';

import type { ChipProps } from '@mui/material';

const DEFAULT_CHIP_PROPS: ChipProps = { size: 'small', color: 'warning' };

/**
 * The label a nav item carries by default.
 */
const NavItemChip: React.FC<ChipProps> = (props) => <Chip {...mergeSlotProps(props, DEFAULT_CHIP_PROPS)} />;

export default NavItemChip;
